export default "__VITE_ASSET__YmjOBkCZ__"